import React, { memo } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  n: 1,
  icon: '📊',
  title: 'Escáner de Niveles',
  desc: 'Ubicá a cualquier alumno en su nivel correcto en menos de 5 minutos. Nunca más adivines en qué tomo tiene que estar.',
  bookColor: 'bg-[#0077B6]',
  spineColor: 'bg-[#023E8A]'
}, {
  n: 2,
  icon: '💪',
  title: 'Tierra Firme',
  desc: 'Rutinas de preparación física en seco de 15 minutos. Lo que el agua no puede trabajar sola: fuerza, movilidad y prevención de lesiones.',
  bookColor: 'bg-[#0096C7]',
  spineColor: 'bg-[#0077B6]'
}, {
  n: 3,
  icon: '🥗',
  title: 'Combustible Acuático',
  desc: 'Guía de nutrición e hidratación para nadadores de todas las edades. El error que el 90% de tus alumnos comete antes de entrar al agua.',
  bookColor: 'bg-[#00B4D8]',
  spineColor: 'bg-[#0096C7]'
}, {
  n: 4,
  icon: '🎮',
  title: 'El Cofre de Juegos',
  desc: '20 dinámicas acuáticas con objetivos técnicos ocultos. Para cuando la clase necesita algo diferente y memorable.',
  bookColor: 'bg-[#023E8A]',
  spineColor: 'bg-[#03045E]'
}, {
  n: 5,
  icon: '🚨',
  title: 'Kit de Supervivencia',
  desc: 'Clases de emergencia para grupos mixtos sin aviso, sin materiales, con 20 minutos o con alumnos de mal humor.',
  bookColor: 'bg-[#48CAE4]',
  spineColor: 'bg-[#00B4D8]'
}, {
  n: 6,
  icon: '📋',
  title: 'Pack de Organización Semanal',
  desc: 'Planillas para eliminar la ansiedad del domingo. Tus cursos, pagos, materiales y pendientes en una sola hoja.',
  bookColor: 'bg-[#0077B6]',
  spineColor: 'bg-[#023E8A]'
}];
function BookMockup({
  n,
  icon,
  bookColor,
  spineColor
}: {
  n: number;
  icon: string;
  bookColor: string;
  spineColor: string;
}) {
  return <div className="flex justify-center py-6" data-id="element-16">
      <div className="relative w-[180px] h-[240px] drop-shadow-xl" data-id="element-17">
        {/* Spine */}
        <div className={`absolute left-0 top-0 bottom-0 w-[18px] ${spineColor} rounded-l-md`} data-id="element-18"></div>
        {/* Cover */}
        <div className={`absolute left-[18px] right-0 top-0 bottom-0 ${bookColor} rounded-r-md flex flex-col justify-between p-5 text-white`} data-id="element-19">
          <div className="text-3xl" data-id="element-20">{icon}</div>
          <div className="text-2xl font-heading font-semibold" data-id="element-21">Bonus {n}</div>
          <div data-id="element-22">
            <div className="w-full h-px bg-white/40 mb-3" data-id="element-23"></div>
            <div className="text-xs tracking-[0.15em] font-medium opacity-90" data-id="element-24">
              NATACIÓN 360™
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function BonusesGrid() {
  return <section className="py-20 bg-brand-mist" data-id="element-25">
      <div className="max-w-6xl mx-auto px-4" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-gray-900 mb-4 tracking-tight" data-id="element-28">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-29">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center gap-2 bg-brand-aqua text-white font-bold px-6 py-3 rounded-full shadow-lg shadow-brand-aqua/30" data-id="element-30">
            <span className="text-xl" data-id="element-31">🎁</span>
            <span className="tracking-wide" data-id="element-32">GRATIS POR EL DÍA DE HOY</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-33">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 flex flex-col text-center" data-id="element-34">
              <BookMockup n={b.n} icon={b.icon} bookColor={b.bookColor} spineColor={b.spineColor} data-id="element-35" />

              <div className="flex justify-center mb-4" data-id="element-36">
                <span className="bg-green-100 text-green-700 font-bold text-sm px-4 py-1 rounded-full tracking-wide" data-id="element-37">
                  GRATIS
                </span>
              </div>

              <h3 className="font-heading font-bold text-xl text-gray-900 mb-4 leading-tight" data-id="element-38">
                <span className="mr-1" data-id="element-39">{b.icon}</span> Bonus {b.n} — {b.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-40">{b.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}